/* HERE WE STORE ONLY BE-RELATED ENUMS (enumLabels.json from assets) */
export {
    default as DamageType,
} from '../types/damageType.enums'

export enum ProductType {
    VAL_1500C = 'VAL_1500C',
    VAL_2500C = 'VAL_2500C',
    VAL_1500CRT = 'VAL_1500CRT',
    VAL_2500CRT = 'VAL_2500CRT',
    VAL_1500XSCOL = 'VAL_1500XSCOL',
    VAL_1500XCOL = 'VAL_1500XCOL',
    VAL_1500XSCRT = 'VAL_1500XSCRT',
    VAL_1500XCRT = 'VAL_1500XCRT',
    VAL_1500F = 'VAL_1500F',
    VAL_1500DF = 'VAL_1500DF',
    VAL_1500DF_EURO = 'VAL_1500DF_EURO',
    VAL_1500DF_EUROMAX = 'VAL_1500DF_EUROMAX',
    VAL_770C = 'VAL_770C',
    VAL_770CRT = 'VAL_770CRT',
    VAL_ONEC = 'VAL_ONEC',
    VAL_ONECRT = 'VAL_ONECRT',
    VAL_PRIME_VIAL = 'VAL_PRIME_VIAL',
    VAL_PRIME_BOTTLE = 'VAL_PRIME_BOTTLE',
    VAL_1500XCOL_MONARCH = 'VAL_1500XCOL_MONARCH',
    VAL_1500XCRT_MONARCH = 'VAL_1500XCRT_MONARCH',
    VAL_1500DF_EUROMAX_MONARCH = 'VAL_1500DF_EUROMAX_MONARCH',
    VAL_6500XCOL = 'VAL_6500XCOL',
    VAL_6500XCRT = 'VAL_6500XCRT',
}

export enum FeeChargeability {
    FIXED_AMOUNT = 'FIXED_AMOUNT',
    INCLUDED = 'INCLUDED',
    PERCENTAGE_BASE_LEASE = 'PERCENTAGE_BASE_LEASE',
    PERCENTAGE_FIXED_AMOUNT_PERIOD = 'PERCENTAGE_FIXED_AMOUNT_PERIOD',
    PERCENTAGE_BASE_LEASE_POSITIONING_PERIOD = 'PERCENTAGE_BASE_LEASE_POSITIONING_PERIOD',
    FIXED_AMOUNT_PER_VEHICLE = 'FIXED_AMOUNT_PER_VEHICLE',
    FIXED_AMOUNT_PER_CONTAINER = 'FIXED_AMOUNT_PER_CONTAINER',
    FIXED_AMOUNT_CONTAINER_SPECIFIC = 'FIXED_AMOUNT_CONTAINER_SPECIFIC',
    FIXED_AMOUNT_PER_DAY_CONTAINER = 'FIXED_AMOUNT_PER_DAY_CONTAINER',
    UNSPECIFIED = 'UNSPECIFIED',
    FIXED_AMOUNT_PER_ORDER = 'FIXED_AMOUNT_PER_ORDER',
    PER_CONTAINER_PER_MONTH = 'PER_CONTAINER_PER_MONTH',
    CONTAINER_SPECIFIC_PER_REQUIREMENT = 'CONTAINER_SPECIFIC_PER_REQUIREMENT',
    PER_CONTAINER_PER_REQUIREMENT = 'PER_CONTAINER_PER_REQUIREMENT',
    PER_GATEWAY = 'PER_GATEWAY',
    PER_CONTAINER_PER_SHIPMENT = 'PER_CONTAINER_PER_SHIPMENT',
    PER_VEHICLE_PER_SHIPMENT = 'PER_VEHICLE_PER_SHIPMENT',
    PER_CONTAINER_PER_ADDL_SHIPMENT = 'PER_CONTAINER_PER_ADDL_SHIPMENT',
    FIXED_AMOUNT_CONTAINER_POSITIONING_PERIOD = 'FIXED_AMOUNT_CONTAINER_POSITIONING_PERIOD',
}

export enum RejectionReason {
    REJECTION_DOUBLE_SELECTION = 'REJECTION_DOUBLE_SELECTION',
    REJECTION_DAMAGED = 'REJECTION_DAMAGED',
    REJECTION_PREASSIGNED_NOT_SELECTED = 'REJECTION_PREASSIGNED_NOT_SELECTED',
    REJECTION_WRONG_LOCATION = 'REJECTION_WRONG_LOCATION',
    REJECTION_PRIORITIZATION = 'REJECTION_PRIORITIZATION',
    REJECTION_OTHER = 'REJECTION_OTHER',
}

export enum Timezone {
    MINUS_1200 = 'MINUS_1200',
    MINUS_1100 = 'MINUS_1100',
    MINUS_1000 = 'MINUS_1000',
    MINUS_0930 = 'MINUS_0930',
    MINUS_0900 = 'MINUS_0900',
    MINUS_0800 = 'MINUS_0800',
    MINUS_0700 = 'MINUS_0700',
    MINUS_0600 = 'MINUS_0600',
    MINUS_0500 = 'MINUS_0500',
    MINUS_0430 = 'MINUS_0430',
    MINUS_0400 = 'MINUS_0400',
    MINUS_0330 = 'MINUS_0330',
    MINUS_0300 = 'MINUS_0300',
    MINUS_0200 = 'MINUS_0200',
    MINUS_0100 = 'MINUS_0100',
    PLUS_0000 = 'PLUS_0000',
    PLUS_0100 = 'PLUS_0100',
    PLUS_0200 = 'PLUS_0200',
    PLUS_0300 = 'PLUS_0300',
    PLUS_0330 = 'PLUS_0330',
    PLUS_0400 = 'PLUS_0400',
    PLUS_0430 = 'PLUS_0430',
    PLUS_0500 = 'PLUS_0500',
    PLUS_0530 = 'PLUS_0530',
    PLUS_0545 = 'PLUS_0545',
    PLUS_0600 = 'PLUS_0600',
    PLUS_0630 = 'PLUS_0630',
    PLUS_0700 = 'PLUS_0700',
    PLUS_0800 = 'PLUS_0800',
    PLUS_0845 = 'PLUS_0845',
    PLUS_0900 = 'PLUS_0900',
    PLUS_0930 = 'PLUS_0930',
    PLUS_1000 = 'PLUS_1000',
    PLUS_1030 = 'PLUS_1030',
    PLUS_1100 = 'PLUS_1100',
    PLUS_1130 = 'PLUS_1130',
    PLUS_1200 = 'PLUS_1200',
    PLUS_1245 = 'PLUS_1245',
    PLUS_1300 = 'PLUS_1300',
    PLUS_1345 = 'PLUS_1345'
}

export enum RangeType {
    BUSINESS_DAYS = 'BUSINESS_DAYS',
    CALENDAR_DAYS = 'CALENDAR_DAYS',
    CALENDAR_DAYS_HOUR = 'CALENDAR_DAYS_HOUR',
}

export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    CHF = 'CHF',
    GBP = 'GBP',
}

export enum ContractCurrency {
    USD = 'USD',
    EUR = 'EUR',
    CHF = 'CHF',
    GBP = 'GBP',
    AUD = 'AUD',
    INR = 'INR',
    CNY = 'CNY',
    SGD = 'SGD',
    CAD = 'CAD',
    JPY = 'JPY',
    KRW = 'KRW'
}

export enum ContainerType {
    MODEL_5BT = 'MODEL_5BT',
    MODEL_5C = 'MODEL_5C',
    MODEL_5CRT = 'MODEL_5CRT',
    MODEL_40 = 'MODEL_40',
    MODEL_40BT = 'MODEL_40BT',
    MODEL_40BT_CRT_C_F_DF = 'MODEL_40BT_CRT_C_F_DF',
    MODEL_40C = 'MODEL_40C',
    MODEL_40CRT = 'MODEL_40CRT',
    MODEL_40DF = 'MODEL_40DF',
    MODEL_40F = 'MODEL_40F',
    MODEL_770C = 'MODEL_770C',
    MODEL_770CRT = 'MODEL_770CRT',
    MODEL_1500C = 'MODEL_1500C',
    MODEL_1500CRT = 'MODEL_1500CRT',
    MODEL_1500DF = 'MODEL_1500DF',
    MODEL_1500DF_EURO = 'MODEL_1500DF_EURO',
    MODEL_1500DF_EURO_MAX = 'MODEL_1500DF_EURO_MAX',
    MODEL_1500DF_F = 'MODEL_1500DF_F',
    MODEL_1500F = 'MODEL_1500F',
    MODEL_1500X = 'MODEL_1500X',
    MODEL_1500X_C = 'MODEL_1500X_C',
    MODEL_1500X_COL = 'MODEL_1500X_COL',
    MODEL_1500X_COLG4 = 'MODEL_1500X_COLG4',
    MODEL_1500X_COLG4_2 = 'MODEL_1500X_COLG4_2',
    MODEL_1500X_CRT = 'MODEL_1500X_CRT',
    MODEL_1500X_CRTG4 = 'MODEL_1500X_CRTG4',
    MODEL_1500X_CRTG4_2 = 'MODEL_1500X_CRTG4_2',
    MODEL_1500X_ERT = 'MODEL_1500X_ERT',
    MODEL_1500X_ERTG4 = 'MODEL_1500X_ERTG4',
    MODEL_1500X_ERTG4_2 = 'MODEL_1500X_ERTG4_2',
    MODEL_1500X_G4 = 'MODEL_1500X_G4',
    MODEL_1500X_G4_2 = 'MODEL_1500X_G4_2',
    MODEL_2500C = 'MODEL_2500C',
    MODEL_2500CRT = '2500CRT',
    MODEL_2500C_CRT = 'MODEL_2500CRT',
    MODEL_2500DF = 'MODEL_2500DF',
    MODEL_2500F = 'MODEL_2500F',
    MODEL_2500X = 'MODEL_2500X',
    MODEL_2500X_C = 'MODEL_2500X_C',
    MODEL_2500X_CRT = 'MODEL_2500X_CRT',
    MODEL_LAB = 'MODEL_LAB',
    MODEL_ONE_C = 'MODEL_ONE_C',
    MODEL_ONE_CRT = 'MODEL_ONE_CRT',
    MODEL_PRIME_BOTTLE = 'MODEL_PRIME_BOTTLE',
    MODEL_PRIME_VIAL = 'MODEL_PRIME_VIAL',
}

export enum LeaseType {
    AIRLINE_LEASE = 'AIRLINE_LEASE',
    DIRECT_LEASE = 'DIRECT_LEASE',
}

export enum LaneStatus {
    AWARDED = 'AWARDED',
    CANCELLED = 'CANCELLED',
    IMPLEMENTED = 'IMPLEMENTED',
    INACTIVE = 'INACTIVE',
    IN_PROGRESS = 'IN_PROGRESS',
    PRICED = 'PRICED',
    REJECTED_CUSTOMER = 'REJECTED_CUSTOMER',
    REJECTED_PRICING = 'REJECTED_PRICING',
    UNDER_REVIEW_PRICING = 'UNDER_REVIEW_PRICING',
    TO_BE_QUOTED = 'TO_BE_QUOTED',
}

export enum LoggerType {
    CARTASENSE = 'CARTASENSE',
    CARTASENSE_M = 'CARTASENSE_M',
    CL_TT_7100 = 'CL_TT_7100',
    MR_810T = 'MR_810T',
    SKYCELL = 'SKYCELL',
    SKYCELL_SAVY_BLE = 'SKYCELL_SAVY_BLE',
    MR_811 = 'MR_811',
    MR_812P = 'MR_812P',
    MR_813 = 'MR_813',
    MR_814 = 'MR_814',
    MR_815 = 'MR_815',
    CL_FRIGGA_V5_PLUS = 'CL_FRIGGA_V5_PLUS',
    MR_816 = 'MR_816',
}

export enum LoggerConfiguration {
    CF_AMBIENT = 'CF_AMBIENT',
    CF_BUTTON = 'CF_BUTTON',
    CF_INTERNAL = 'CF_INTERNAL',
    CF_TOP = 'CF_TOP',
    CF_BOTTOM = 'CF_BOTTOM',
    CF_LEFT = 'CF_LEFT',
    CF_RIGHT = 'CF_RIGHT',
    CF_BACK = 'CF_BACK',
    CF_DOOR = 'CF_DOOR',
    CF_UNSPECIFIED = 'CF_UNSPECIFIED',
    CF_SAVY_NOT_APPLICABLE = 'CF_SAVY_NOT_APPLICABLE',
    AMBIENT_BACKPLANE = 'AMBIENT_BACKPLANE',
    CF_MR_812P_AMBIENT = 'CF_MR_812P_AMBIENT',
    CF_MR_813_AMBIENT = 'CF_MR_813_AMBIENT',
    CF_MR_813_AMBIENT_TEST = 'CF_MR_813_AMBIENT_TEST',
    CF_MR_813_INTERNAL_TEST = 'CF_MR_813_INTERNAL_TEST',
}

export enum SensorCode {
    CONNECTOR_1 = 'CONNECTOR_1',
    CONNECTOR_2 = 'CONNECTOR_2',
    CONNECTOR_3 = 'CONNECTOR_3',
    CONNECTOR_4 = 'CONNECTOR_4',
    CONNECTOR_5 = 'CONNECTOR_5',
    CONNECTOR_6 = 'CONNECTOR_6',
    CONNECTOR_DOOR = 'CONNECTOR_DOOR',
    INTEGRATED = 'INTEGRATED',
    ON_BOARD_CONNECTOR = 'ON_BOARD_CONNECTOR',
    ONE_WIRE_1 = 'ONE_WIRE_1',
    ONE_WIRE_2 = 'ONE_WIRE_2',
    ONE_WIRE_3 = 'ONE_WIRE_3',
    ONE_WIRE_4 = 'ONE_WIRE_4',
    ONE_WIRE_5 = 'ONE_WIRE_5',
    ONE_WIRE_6 = 'ONE_WIRE_6',
    HUMIDITY = 'HUMIDITY',
}

export enum ContactMainType {
    BILLING = 'BILLING',
    CLIENT_SERVICES = 'CLIENT_SERVICES',
    OPERATIONS = 'OPERATIONS',
    TECHNICAL_SERVICES = 'TECHNICAL_SERVICES'
}

export enum LocationType {
    ADDRESS = 'ADDRESS',
    AIRPORT = 'AIRPORT',
    RAILPORT = 'RAILPORT',
    SEAPORT = 'SEAPORT'
}

export enum AddressCategory {
    ASSET_TRACKING = 'ASSET_TRACKING',
    AIRLINE = 'AIRLINE',
    CAREOF = 'CAREOF',
    CONSIGNEE = 'CONSIGNEE',
    CONSOLIDATEDPOINT = 'CONSOLIDATEDPOINT',
    CUSTOMER = 'CUSTOMER',
    CUSTOMER_QUOTATION = 'CUSTOMER_QUOTATION',
    CLIENT_CONSIGNMENT_STOCK = 'CLIENT_CONSIGNMENT_STOCK',
    FORWARDER = 'FORWARDER',
    FORWARDERCUSTOMS = 'FORWARDERCUSTOMS',
    FORWARDERPOSITIONING = 'FORWARDERPOSITIONING',
    FORWARDERTRUCKING = 'FORWARDERTRUCKING',
    FWD_EXPORT_AIR = 'FWD_EXPORT_AIR',
    FWD_EXPORT_ROAD = 'FWD_EXPORT_ROAD',
    FWD_EXPORT_SEA = 'FWD_EXPORT_SEA',
    FWD_IMPORT_AIR = 'FWD_IMPORT_AIR',
    FWD_IMPORT_ROAD = 'FWD_IMPORT_ROAD',
    FWD_IMPORT_SEA = 'FWD_IMPORT_SEA',
    FWD_POSITIONING_AIR = 'FWD_POSITIONING_AIR',
    FWD_POSITIONING_ROAD = 'FWD_POSITIONING_ROAD',
    FWD_POSITIONING_SEA = 'FWD_POSITIONING_SEA',
    GATEWAYSTATION = 'GATEWAYSTATION',
    HANDOVERPOINT = 'HANDOVERPOINT',
    INSTITUTE = 'INSTITUTE',
    LSPWAREHOUSE = 'LSPWAREHOUSE',
    NOTIFYPARTY = 'NOTIFYPARTY',
    PHARMACOMPANY = 'PHARMACOMPANY',
    PHARMAWAREHOUSE = 'PHARMAWAREHOUSE',
    SERVICECENTER = 'SERVICECENTER',
    SERVICEPROVIDER = 'SERVICEPROVIDER',
    SUPPLIER = 'SUPPLIER',
    LOGGER_CENTER = 'LOGGER_CENTER',
}

export enum ContactType {
    SCAPPQM = 'SCAPPQM',
    PROVISION = 'PROVISION',
    SCAPPUSER = 'SCAPPUSER',
    CLAIMS_RESPONSIBLE = 'CLAIMS_RESPONSIBLE',
    NOTIFICATION_ORDER_MGMT = 'NOTIFICATION_ORDER_MGMT',
    OPS_DAILY = 'OPS_DAILY',
    OPS_PROCUREMENT = 'OPS_PROCUREMENT',
    OPS_BILLING = 'OPS_BILLING',
    OPS_PM = 'OPS_PM',
    OPS_POOLING = 'OPS_POOLING',
    PRICING = 'PRICING',
    ROAD_RESPONSIBLE = 'ROAD_RESPONSIBLE',
    AIREXPORT_RESPONSIBLE = 'AIREXPORT_RESPONSIBLE',
    SEAEXPORT_RESPONSIBLE = 'SEAEXPORT_RESPONSIBLE',
    AIRIMPORT_RESPONSIBLE = 'AIRIMPORT_RESPONSIBLE',
    SEAIMPORT_RESPONSIBLE = 'SEAIMPORT_RESPONSIBLE',
    RAIL_RESPONSIBLE = 'RAIL_RESPONSIBLE',
    SKYCELL = 'SKYCELL',
    SKYMIND_CUSTOMER = 'SKYMIND_CUSTOMER',
    SKYCELL_COMMERCIAL = 'SKYCELL_COMMERCIAL',
    BILLING_CONTACT = 'BILLING_CONTACT',
}

export enum NotificationTypes {
    FOLLOW_UP = 'FOLLOW_UP',
    NOTIFICATION = 'NOTIFICATION',
}

export enum NotificationRecipientType {
    CUSTOMER = 'CUSTOMER',
    CONSIGNEE = 'CONSIGNEE',
    EVENT_CONTACT = 'EVENT_CONTACT',
    FORWARDER_CUSTOMS = 'FORWARDER_CUSTOMS',
    FORWARDER_EXPORT = 'FORWARDER_EXPORT',
    FORWARDER_POSITIONING = 'FORWARDER_POSITIONING',
    FORWARDER_TRUCKING = 'FORWARDER_TRUCKING',
    FORWARDER_ROAD_INTERNAL_PICKUP = 'FORWARDER_ROAD_INTERNAL_PICKUP',
    FORWARDER_ROAD_INTERNAL_DELIVERY = 'FORWARDER_ROAD_INTERNAL_DELIVERY',
    FORWARDER_ROAD_INTERNAL = 'FORWARDER_ROAD_INTERNAL',
    FORWARDER_AIR_INTERNAL = 'FORWARDER_AIR_INTERNAL',
    FORWARDER_AIR_ROAD_INTERNAL = 'FORWARDER_AIR_ROAD_INTERNAL',
    FORWARDER_SEA_INTERNAL = 'FORWARDER_SEA_INTERNAL',
    FORWARDER_SEA_ROAD_INTERNAL = 'FORWARDER_SEA_ROAD_INTERNAL',
    FORWARDER_ROAD_TO_EVENT = 'FORWARDER_ROAD_TO_EVENT',
    FORWARDER_ROAD_FROM_EVENT = 'FORWARDER_ROAD_FROM_EVENT',
    HANDOVER_POINT = 'HANDOVER_POINT',
    ORIGIN_LOCATION = 'ORIGIN_LOCATION',
    DESTINATION_LOCATION = 'DESTINATION_LOCATION',
    SKYCELL_BILLING = 'SKYCELL_BILLING',
    SKYCELL_TECHNICALSERVICES = 'SKYCELL_TECHNICALSERVICES',
    SKYCELL_OPS = 'SKYCELL_OPS',
    ORIGIN_LOCATION_PROVISION = 'ORIGIN_LOCATION_PROVISION',
    DROPOFFPOINT = 'DROPOFFPOINT',
    EVENT_BOOKER = 'EVENT_BOOKER',
    SERVICE_CENTER_SKYCENTER_REPORT = 'SERVICE_CENTER_SKYCENTER_REPORT',
    SKYCELL_POOLING = 'SKYCELL_POOLING',
    CONTAINER_INFO = 'CONTAINER_INFO',
    PRICING = 'PRICING',
    CXMANAGERS = 'CXMANAGERS',
}

export enum ContainerVolume {
    VOLUME_1 = 'VOLUME_1',
    VOLUME_5 = 'VOLUME_5',
    VOLUME_40 = 'VOLUME_40',
    VOLUME_770 = 'VOLUME_770',
    VOLUME_1190 = 'VOLUME_1190',
    VOLUME_1500 = 'VOLUME_1500',
    VOLUME_2500 = 'VOLUME_2500',
    VOLUME_6500 = 'VOLUME_6500',
    VOLUME_0_000_3 = 'VOLUME_0_000_3',
    VOLUME_0_008 = 'VOLUME_0_008',
    VOLUME_0_209 = 'VOLUME_0_209',
}

export enum ContainerCode {
    _000 = '_000',
    _002 = '_002',
    _011 = '_011',
    _012 = '_012',
    _013 = '_013',
    _031 = '_031',
    _032 = '_032',
    _021 = '_021',
    _022 = '_022',
    _024 = '_024',
    _051 = '_051',
    _052 = '_052',
    _101 = '_101',
    _102 = '_102',
    _103 = '_103',
    _104 = '_104',
    _105 = '_105',
    _106 = '_106',
    _107 = '_107',
    _108 = '_108',
    _109 = '_109',
    _110 = '_110',
    _111 = '_111',
    _120 = '_120',
    _801 = '_801',
    _802 = '_802',
    _803 = '_803',
    _804 = '_804',
    _805 = '_805',
    _806 = '_806',
    _807 = '_807',
    _808 = '_808',
    _809 = '_809',
    _810 = '_810',
    _999 = '_999'
}

export enum ContainerGeneration {
    G1 = 'G1',
    G2 = 'G2',
    G3 = 'G3',
    G4 = 'G4',
    G4_2 = 'G4.2',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export enum TemperatureRange {
    BT = 'BT',
    BT_C_CRT_F_DF = 'BT_C_CRT_F_DF',
    C = 'C',
    C_AND_CRT = 'C_AND_CRT',
    C_CRT_ERT = 'C_CRT_ERT',
    CRT = 'CRT',
    DF = 'DF',
    F = 'F',
    F_AND_DF = 'F_AND_DF',
    UNDEFINED = 'UNDEFINED'
}

export enum OrderTemperatureRange {
    ANY_TEMP_RANGE = 'ANY_TEMP_RANGE',
    BT = 'BT',
    C = 'C',
    CRT = 'CRT',
    DF = 'DF',
    F = 'F',
}

export enum LaneGroupTemperatureRange {
    C = 'C',
    CRT = 'CRT',
    DF = 'DF',
    F = 'F',
}

export enum TemperatureRangeAll {
    BT = 'BT',
    C = 'C',
    CRT = 'CRT',
    DF = 'DF',
    DRY = 'DRY',
    ERT = 'ERT',
    F = 'F',
}

export enum DefaultTemperatureRange {
    BT = 'BT',
    C = 'C',
    CRT = 'CRT',
    DF = 'DF',
    ERT = 'ERT',
    F = 'F',
}

export enum TemperatureRangePreconditioned {
    BT = 'BT',
    C = 'C',
    CRT = 'CRT',
    DF = 'DF',
    F = 'F',
    ERT = 'ERT'
}

export enum AdditionalFeesStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    VALID = 'VALID',
    CANCELLED = 'CANCELLED'
}

export enum ContainerStatus {
    BOOKED_TO_ORDER = 'BOOKED_TO_ORDER',
    CHECK_PRECONDITIONING = 'CHECK_PRECONDITIONING',
    CHECK_STATUS = 'CHECK_STATUS',
    CLEANED = 'CLEANED',
    EVENT = 'EVENT',
    ICED = 'ICED',
    IN_PRODUCTION = 'IN_PRODUCTION',
    IN_TESTING = 'IN_TESTING',
    INSTALL_TEST_LOGGER = 'INSTALL_TEST_LOGGER',
    LOST = 'LOST',
    OK = 'OK',
    ORDER_CLOSED = 'ORDER_CLOSED',
    PERFORMANCE_FAILED_INSULATION = 'PERFORMANCE_FAILED_INSULATION',
    PERFORMANCE_FAILED_PCM = 'PERFORMANCE_FAILED_PCM',
    POSITIONING = 'POSITIONING',
    PRECONDITIONED = 'PRECONDITIONED',
    PRECONDITIONING = 'PRECONDITIONING',
    PRECON_FAILED_DATA = 'PRECON_FAILED_DATA',
    PRECON_FAILED_TEMPERATURE = 'PRECON_FAILED_TEMPERATURE',
    PRE_APPROVED = 'PRE_APPROVED',
    PRE_SELECTED = 'PRE_SELECTED',
    QC_FAILED_DATA = 'QC_FAILED_DATA',
    QC_FAILED_PERFORMANCE = 'QC_FAILED_PERFORMANCE',
    QC_FAILED_TEMPERATURE = 'QC_FAILED_TEMPERATURE',
    QC_PASSED = 'QC_PASSED',
    QC_PASSED_AUTOMATED = 'QC_PASSED_AUTOMATED',
    READY_TO_SHIP = 'READY_TO_SHIP',
    RECYCLED = 'RECYCLED',
    RELEASED_FROM_ORDER = 'RELEASED_FROM_ORDER',
    RELEASED_FROM_PRODUCTION = 'RELEASED_FROM_PRODUCTION',
    RETURNED_DAMAGED = 'RETURNED_DAMAGED',
    RETURNED_OK = 'RETURNED_OK',
    SCRAPPED = 'SCRAPPED',
    TO_BE_MAINTAINED = 'TO_BE_MAINTAINED',
    TO_BE_OVERHAULED = 'TO_BE_OVERHAULED',
    TO_BE_PROVISIONED = 'TO_BE_PROVISIONED',
    TO_BE_RECYCLED = 'TO_BE_RECYCLED',
    TO_BE_REINSPECTED = 'TO_BE_REINSPECTED',
    TO_BE_REPAIRED = 'TO_BE_REPAIRED',
    TO_BE_ICED = 'TO_BE_ICED',
    TO_BE_LOGGER_EXCHANGED = 'TO_BE_LOGGER_EXCHANGED',
    TO_BE_PRECONDITIONED = 'TO_BE_PRECONDITIONED',
    TO_BE_RECEIVED = 'TO_BE_RECEIVED',
    TO_BE_RECONDITIONED = 'TO_BE_RECONDITIONED',
    TRANSPORT = 'TRANSPORT',
    TS_APPROVED = 'TS_APPROVED',
    UNCHECKED = 'UNCHECKED',
    UNUSED = 'UNUSED',
}

export enum ContainerSensorCheckType {
    QC_CHECK = 'QC_CHECK',
    DEFAULT_LOGGER_TYPE_CHECK = 'DEFAULT_LOGGER_TYPE_CHECK',
    PRECONC_CHECK = 'PRECONC_CHECK',
    PRECONCRT_CHECK = 'PRECONCRT_CHECK',
}

export enum ContainerOutcomeCode {
    SUCCESS = 'SUCCESS',
    FAILED_DATA = 'FAILED_DATA',
    FAILED_TEMPERATURE = 'FAILED_TEMPERATURE',
    FAILED_NO_STATUS_CHANGE = 'FAILED_NO_STATUS_CHANGE',
    FAILED_DATA_RECONDITION = 'FAILED_DATA_RECONDITION',
}

export enum ServiceProcess {
    RECEPTION = 'RECEPTION',
    INSPECTION = 'INSPECTION',
    CLEANING = 'CLEANING',
    PRECONDITIONING_START = 'PRECONDITIONING_START',
    PRECONDITIONING_END = 'PRECONDITIONING_END',
    ICING = 'ICING',
    PROVISION = 'PROVISION',
    MAINTENANCE = 'MAINTENANCE',
    REPAIR = 'REPAIR',
    OVERHAUL = 'OVERHAUL',
    ASSEMBLY = 'ASSEMBLY',
    LOGGER_EXCHANGE = 'LOGGER_EXCHANGE',
    RECONDITIONING_START = 'RECONDITIONING_START',
    PROOF_OF_DELIVERY = 'PROOF_OF_DELIVERY',
}

export enum LongTermLeaseFeeStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    VALID = 'VALID',
    CANCELLED = 'CANCELLED',
}

export enum LaneFeesStatus {
    AWARDED = 'AWARDED',
    CANCELLED = 'CANCELLED',
    IN_PROGRESS = 'IN_PROGRESS',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}

export enum PricingStatus {
    CANCELLED = 'CANCELLED',
    VALID = 'VALID',
    IN_PROGRESS = 'IN_PROGRESS',
}

export enum Frequency {
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    ANNUALLY = 'ANNUALLY'
}

export enum StepTypeDetailed {
    ROAD_DELIVERY = 'ROAD_DELIVERY',
    ROAD_PICKUP = 'ROAD_PICKUP',
    ROAD_TRACKING = 'ROAD_TRACKING',
    ROAD_INTERNAL = 'ROAD_INTERNAL',
    ROAD_INTERNAL_PICKUP = 'ROAD_INTERNAL_PICKUP',
    ROAD_INTERNAL_DELIVERY = 'ROAD_INTERNAL_DELIVERY',
    AIR_COLLECTION = 'AIR_COLLECTION',
    AIR_TRACKING = 'AIR_TRACKING',
    AIR_INTERNAL = 'AIR_INTERNAL',
    AIR_ROAD_INTERNAL = 'AIR_ROAD_INTERNAL',
    SEA_INTERNAL = 'SEA_INTERNAL',
    SEA_ROAD_INTERNAL = 'SEA_ROAD_INTERNAL',
    UNLOADING_CONFIRM = 'UNLOADING_CONFIRM',
    DROPOFF_CONFIRM = 'DROPOFF_CONFIRM',
    EVENT_EVENT = 'EVENT_EVENT',
    ROAD_TO_EVENT = 'ROAD_TO_EVENT',
    ROAD_FROM_EVENT = 'ROAD_FROM_EVENT',
    CUSTOMS_CUSTOMS = 'CUSTOMS_CUSTOMS',
    RAIL_INTERNAL = 'RAIL_INTERNAL'
}

export enum FreightTypes {
    CONTAINERS = 'CONTAINERS',
    GENERAL_FREIGHT = 'GENERAL_FREIGHT',
}

export enum OrderStatuses {
    NOT_STARTED = 'NOT_STARTED',
    SELECTED = 'SELECTED',
    BOOKED = 'BOOKED',
    TRANSPORT = 'TRANSPORT',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
    TO_BE_PROVISIONED = 'TO_BE_PROVISIONED',
    READY_TO_SHIP = 'READY_TO_SHIP',
    POSITIONING = 'POSITIONING',
    RESERVED = 'RESERVED',
    RENTAL = 'RENTAL',
}

export enum ContainerNoteType {
    CONTAINER_LOCATION_CHANGE = 'CONTAINER_LOCATION_CHANGE',
    CONTAINER_STATUS_CHANGE = 'CONTAINER_STATUS_CHANGE',
    GENERAL_STATUS_CHANGE = 'GENERAL_STATUS_CHANGE',
    LOGGER_EXCHANGE = 'LOGGER_EXCHANGE',
    LOGGER_REMOVAL = 'LOGGER_REMOVAL',
    NOTE = 'NOTE'
}

export enum PaymentTerms {
    PAYMENT_TERMS_0_DAYS = 'PAYMENT_TERMS_0_DAYS',
    PAYMENT_TERMS_30_DAYS = 'PAYMENT_TERMS_30_DAYS',
    PAYMENT_TERMS_45_DAYS = 'PAYMENT_TERMS_45_DAYS',
    PAYMENT_TERMS_60_DAYS = 'PAYMENT_TERMS_60_DAYS',
    PAYMENT_TERMS_90_DAYS = 'PAYMENT_TERMS_90_DAYS',
}

export enum InvoiceDesignation {
    BASELEASE = 'BASELEASE',
    CANCELLATION = 'CANCELLATION',
    CREDIT_NOTE = 'CREDIT_NOTE',
    DAMAGE = 'DAMAGE',
    EXTRADAYS = 'EXTRADAYS',
    LOSS = 'LOSS',
}

export enum SimplifiedCQuoteReason {
    PRICE = 'PRICE',
    TIMELINE = 'TIMELINE',
}

export enum SubstepName {
    REQUESTED_PICKUP = 'REQUESTED_PICKUP',
    DRIVER_DETAILS = 'DRIVER_DETAILS',
    ACTUAL_PICKUP = 'ACTUAL_PICKUP',
    ADD_INFO = 'ADD_INFO',
    ADD_PICKUP = 'ADD_PICKUP',
    CONFIRMATION = 'CONFIRMATION',
    CLOSED = 'CLOSED',
    COLLECTED = 'COLLECTED',
    CREATION = 'CREATION',
    PICKED_UP = 'PICKED_UP',
    IN_FLIGHT = 'IN_FLIGHT',
    DEPARTURE = 'DEPARTURE',
    ARRIVAL = 'ARRIVAL',
    ENTERED = 'ENTERED',
    CONFIRMED = 'CONFIRMED',
    EVENT = 'EVENT'
}

export enum DamageStatus {
    REPORTED = 'REPORTED',
    CANCELLED = 'CANCELLED',
    FIXED = 'FIXED'
}

export enum ReportingDepartment {
    TECHNICAL_SERVICES = 'TECHNICAL_SERVICES',
    OPERATIONS = 'OPERATIONS',
    PRODUCTION = 'PRODUCTION',
    OTHER = 'OTHER'
}

export enum RegionZeroLevel {
    AMERICAS = 'AMERICAS',
    EMEA = 'EMEA',
    APAC = 'APAC',
}

export enum RegionFirstLevel {
    AMERICA_NORTH = 'AMERICA_NORTH',
    AMERICA_SOUTH = 'AMERICA_SOUTH',
    EUROPE = 'EUROPE',
    AFRICA = 'AFRICA',
    MIDDLE_EAST = 'MIDDLE_EAST',
    ASIA_SOUTH = 'ASIA_SOUTH',
    ASIA_SOUTHEAST = 'ASIA_SOUTHEAST',
    ASIA_EAST = 'ASIA_EAST',
    OCEANIA = 'OCEANIA',
    REST_OF_THE_WORLD = 'REST_OF_THE_WORLD',
}

export enum RegionSecondLevel {
    MEXICO = 'MEXICO',
    PUERTO_RICO = 'PUERTO_RICO',
    AMERICA_CENTRAL_REST = 'AMERICA_CENTRAL_REST',
    CANADA_WEST = 'CANADA_WEST',
    CANADA_MID = 'CANADA_MID',
    CANADA_EAST = 'CANADA_EAST',
    US_MIDWEST = 'US_MIDWEST',
    US_NORTHEAST = 'US_NORTHEAST',
    US_SOUTHWEST = 'US_SOUTHWEST',
    US_SOUTHEAST = 'US_SOUTHEAST',
    US_WEST = 'US_WEST',
    BRAZIL = 'BRAZIL',
    ARGENTINA = 'ARGENTINA',
    AMERICA_SOUTH_REST = 'AMERICA_SOUTH_REST',
    EUROPE_CENTRAL = 'EUROPE_CENTRAL',
    EUROPE_EAST = 'EUROPE_EAST',
    EUROPE_SOUTHWEST = 'EUROPE_SOUTHWEST',
    SCANDINAVIA = 'SCANDINAVIA',
    UNITED_KINGDOM = 'UNITED_KINGDOM',
    IRELAND = 'IRELAND',
    EGYPT = 'EGYPT',
    KENYA = 'KENYA',
    SOUTH_AFRICA = 'SOUTH_AFRICA',
    AFRICA_REST = 'AFRICA_REST',
    ISRAEL = 'ISRAEL',
    MIDDLE_EAST_REST = 'MIDDLE_EAST_REST',
    INDIA_HYDERABAD = 'INDIA_HYDERABAD',
    INDIA_BANGALORE = 'INDIA_BANGALORE',
    INDIA_REST = 'INDIA_REST',
    ASIA_SOUTH_REST = 'ASIA_SOUTH_REST',
    SINGAPORE = 'SINGAPORE',
    ASIA_SOUTHEAST_REST = 'ASIA_SOUTHEAST_REST',
    CHINA_NORTH = 'CHINA_NORTH',
    CHINA_SOUTH = 'CHINA_SOUTH',
    JAPAN = 'JAPAN',
    SOUTH_KOREA = 'SOUTH_KOREA',
    AUSTRALIA_WEST = 'AUSTRALIA_WEST',
    AUSTRALIA_CENTRAL = 'AUSTRALIA_CENTRAL',
    AUSTRALIA_EAST = 'AUSTRALIA_EAST',
    NEW_ZEALAND = 'NEW_ZEALAND',
    ITALY = 'ITALY',
    MALAYSIA = 'MALAYSIA',
    REST_OF_THE_WORLD = 'REST_OF_THE_WORLD',
}

export enum OpportunityFrequency {
    ANNUAL = 'ANNUAL',
    ONE_OFF = 'ONE OFF',
    SEASONAL = 'SEASONAL',
}

export enum OpportunityPalletType {
    EU = 'EU',
    LOOSE_LOAD = 'LOOSE_LOAD',
    OTHER = 'OTHER',
    UNKNOWN = 'UNKNOWN',
    US = 'US',
}

export enum OpportunityStatus {
    OPEN = 'OPEN',
    LOST = 'LOST',
    WON = 'WON',
}

export enum paymentSchedule {
    PAYMENT_SCHEDULE_DAILY = 'PAYMENT_SCHEDULE_DAILY',
    PAYMENT_SCHEDULE_WEEKLY = 'PAYMENT_SCHEDULE_WEEKLY',
    PAYMENT_SCHEDULE_BIWEEKLY = 'PAYMENT_SCHEDULE_BIWEEKLY',
    PAYMENT_SCHEDULE_10DAYS = 'PAYMENT_SCHEDULE_10DAYS',
    PAYMENT_SCHEDULE_MONTHLY = 'PAYMENT_SCHEDULE_MONTHLY',
}

export enum DaysOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}

export enum operationalDays {
    MONDAY_FRIDAY = 'MONDAY_FRIDAY',
    MONDAY_SUNDAY = 'MONDAY_SUNDAY',
    SUNDAY_THURSDAY = 'SUNDAY_THURSDAY',
}

export enum BaseLeaseCategory {
    STANDARD = 'STANDARD',
    ASIA = 'ASIA',
    BRAZIL = 'BRAZIL',
    CHINA = 'CHINA',
    INDIA = 'INDIA'
}

export enum PickupFeeType {
    CHARGE = 'CHARGE',
    FREE = 'FREE',
    NOT_AVAILABLE = 'NOT_AVAILABLE'
}

export enum FxRateType {
    POOLING_FX = 'POOLING_FX',
    PRICING_FX = 'PRICING_FX',
}

export enum AccountStatus {
    CUSTOMER = 'CUSTOMER',
    PROSPECT = 'PROSPECT'
}

export enum QuoteStatus {
    CREATED = 'CREATED',
    IN_PROGRESS = 'IN_PROGRESS',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED',
    PRICED = 'PRICED',
}

export enum LaneQuoteViewType {
    DETAILED_VIEW = 'DETAILED_VIEW',
    ALL_IN_VIEW = 'ALL_IN_VIEW',
}

export enum LaneFeeTemplate {
    DETAILED_FEES_VIEW = 'DETAILED_FEES_VIEW',
    CONSOLIDATED_FEES_VIEW = 'CONSOLIDATED_FEES_VIEW',
}

export enum SimplifiedQuoteStatus {
    UNKNOWN = 'UNKNOWN',
    LOST = 'LOST',
    WON = 'WON'
}

export enum TemperatureRangeCQuote {
    C = 'C',
    CRT = 'CRT',
}

export enum ProductTypeCQuote {
    VAL_1500XCOL = 'VAL_1500XCOL',
    VAL_1500XCRT = 'VAL_1500XCRT',
}

export enum LeaseTypePossibilityStatus {
    AIRLINE_LEASE_REQUIRED_ROUND_TRIP_REQUIRED = 'AIRLINE_LEASE_REQUIRED_ROUND_TRIP_REQUIRED',
    AIRLINE_LEASE_REQUIRED_ONE_WAY_POSSIBLE = 'AIRLINE_LEASE_REQUIRED_ONE_WAY_POSSIBLE',
    DIRECT_LEASE_POSSIBLE = 'DIRECT_LEASE_POSSIBLE',
}

export enum QuotationLevel {
    REGION_SECOND_LEVEL = 'REGION_SECOND_LEVEL',
    COUNTRY = 'COUNTRY',
    IATA = 'IATA',
}

export enum CQuoteCreateMethod {
    SIMPLIFIED_C_QUOTE = 'Simplified C-Quote',
    C_QUOTE = 'C-Quote',
}

export enum CollectionServiceTypeSimplifiedCQuote {
    COLLECTION = 'COLLECTION',
    DROPOFF_SKYCELL = 'DROPOFF_SKYCELL',
}

export enum ReasonForWonLost {
    PRICE = 'PRICE',
    POSITIONING_COLLECTION = 'POSITIONING_COLLECTION',
    AVAILABILITY = 'AVAILABILITY',
    PERFORMANCE = 'PERFORMANCE',
    QUALITY = 'QUALITY ',
    SUSTAINABILITY = 'SUSTAINABILITY',
    STRATEGIC_CLIENT_DECISION = 'STRATEGIC_CLIENT_DECISION',
    REFERRAL = 'REFERRAL',
    VALIDATION_CHALLENGES = 'VALIDATION_CHALLENGES',
    COMPETITION_PARTNERSHIPS = 'COMPETITION_PARTNERSHIPS',
    ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
    OTHERS = 'OTHERS',
}

export enum Packaging {
    CSAFE_RAP = 'CSAFE_RAP',
    CSAFE_RKN = 'CSAFE_RKN',
    DOKASCH_OPTICOOLER_RAP = 'DOKASCH_OPTICOOLER_RAP',
    DOKASCH_OPTICOOLER_RKN = 'DOKASCH_OPTICOOLER_RKN',
    ENVIROTAINER_RAP_E2 = 'ENVIROTAINER_RAP_E2',
    ENVIROTAINER_RAP_T2 = 'ENVIROTAINER_RAP_T2',
    ENVIROTAINER_RELEYE_RLP = 'ENVIROTAINER_RELEYE_RLP',
    ENVIROTAINER_RKN_E1 = 'ENVIROTAINER_RKN_E1',
    ENVIROTAINER_RKN_T2 = 'ENVIROTAINER_RKN_T2',
    OTHER = 'OTHER',
    PELI_COOLPALL_FLEX = 'PELI_COOLPALL_FLEX',
    PELI_COOLPALL_VERTOS = 'PELI_COOLPALL_VERTOS',
    PELI_COOLPALL_VERTOS_ADVANCED = 'PELI_COOLPALL_VERTOS_ADVANCED',
    PELI_CREDO_CARGO = 'PELI_CREDO_CARGO',
    PELI_CREDO_XTREME_FULL_STACK_PALLET = 'PELI_CREDO_XTREME_FULL_STACK_PALLET',
    PELI_CREDO_XTREME_HALF_STACK_PALLET = 'PELI_CREDO_XTREME_HALF_STACK_PALLET',
    SOFRIGAM = 'SOFRIGAM',
    SOFTBOX = 'SOFTBOX',
    TOWER_EURO_PALLET = 'TOWER_EURO_PALLET',
    TOWER_KT400D_60_DEEP_FROZEN_200L = 'TOWER_KT400D_60_DEEP_FROZEN_200L',
    TOWER_KTM42D_DEEP_FROZEN_DOUBLE_PALLET = 'TOWER_KTM42D_DEEP_FROZEN_DOUBLE_PALLET',
    TOWER_SUB_PALLET = 'TOWER_SUB_PALLET',
    TOWER_US_PALLET = 'TOWER_US_PALLET',
    VA_Q_PAL = 'VA_Q_PAL',
    VA_Q_TAINER_EUROX = 'VA_Q_TAINER_EUROX',
    VA_Q_TAINER_TWINX = 'VA_Q_TAINER_TWINX',
    VA_Q_TAINER_USX = 'VA_Q_TAINER_USX',
    VA_Q_TAINER_XLX = 'VA_Q_TAINER_XLX',
    UNKNOWN = 'UNKNOWN',
}

export enum IndustryType {
    AIRLINE = 'AIRLINE',
    ACTIVE_PHARMACEUTICAL_INGREDIENT = 'ACTIVE_PHARMACEUTICAL_INGREDIENT',
    BANKING = 'BANKING',
    BIOTECH = 'BIOTECH',
    CHEMICALS = 'CHEMICALS',
    CONTRACT_MANUFACTURING_ORGANIZATION = 'CONTRACT_MANUFACTURING_ORGANIZATION',
    COMPETITOR = 'COMPETITOR',
    CONTRACT_RESEARCH_ORGANIZATION = 'CONTRACT_RESEARCH_ORGANIZATION',
    FOOD_SUPPLY = 'FOOD_SUPPLY',
    FREIGHT_FORWARDER = 'FREIGHT_FORWARDER',
    GOVERNMENT = 'GOVERNMENT',
    HEALTHCARE = 'HEALTHCARE',
    INVESTOR = 'INVESTOR',
    LOGISTIC_COMPANY = 'LOGISTIC_COMPANY',
    MEDIA = 'MEDIA',
    MEDICAL_CANNABIS = 'MEDICAL_CANNABIS',
    MEDICAL_DEVICES = 'MEDICAL_DEVICES',
    NON_GOVERNMENT_ORGANISATION = 'NON_GOVERNMENT_ORGANISATION',
    NON_PROFIT_ORGANIZATION = 'NON_PROFIT_ORGANIZATION',
    OTHER = 'OTHER',
    PHARMACEUTICAL_COMPANY = 'PHARMACEUTICAL_COMPANY',
    PHARMACEUTICAL_MANUFACTURER = 'PHARMACEUTICAL_MANUFACTURER',
    RESEARCH = 'RESEARCH'
}

export enum OrderTrackingByApi {
    DSV = 'DSV',
}

export enum StorageType {
    C = 'C',
    CRT = 'CRT',
    DRY = 'DRY',
    DF = 'DF',
}

export enum StorageSpaceRatio {
    _1_1 = '_1_1',
    _1_2 = '_1_2',
    _2_3 = '_2_3',
    _3_4 = '_3_4',
    _4_5 = '_4_5',
    _5_6 = '_5_6',
    _6_7 = '_6_7',
    _9_10 = '_9_10',
}

export enum AddressMainCategory {
    AIRLINE = 'AIRLINE',
    CONSIGNEE = 'CONSIGNEE',
    FORWARDER = 'FORWARDER',
    GENERAL = 'GENERAL',
    INSTITUTE = 'INSTITUTE',
    PHARMA_WAREHOUSE = 'PHARMA_WAREHOUSE',
    SERVICECENTER = 'SERVICECENTER',
    SUPPLIER = 'SUPPLIER',
    ASSET_TRACKING = 'ASSET_TRACKING',
}

export enum ServiceCenterStatus {
    PLANNED = 'PLANNED',
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
}

export enum ContainerAvailabilityAllowedProductTypes {
    VAL_1500C = 'VAL_1500C',
    VAL_2500C = 'VAL_2500C',
    VAL_1500XCOL = 'VAL_1500XCOL',
    VAL_1500XCOL_MONARCH = 'VAL_1500XCOL_MONARCH',
    VAL_1500CRT = 'VAL_1500CRT',
    VAL_2500CRT = 'VAL_2500CRT',
    VAL_1500XCRT = 'VAL_1500XCRT',
    VAL_1500XCRT_MONARCH = 'VAL_1500XCRT_MONARCH',
}

export enum ServiceCenterType {
    DRY_STORAGE_CENTER = 'DRY_STORAGE_CENTER',
    CONSIGNMENT_CENTER = 'CONSIGNMENT_CENTER',
    CLIENT_CONSIGNMENT_STOCK = 'CLIENT_CONSIGNMENT_STOCK',
    REPAIR_CENTER = 'REPAIR_CENTER',
    SERVICE_CENTER = 'SERVICE_CENTER',
    OVERHAUL_CENTER = 'OVERHAUL_CENTER',
    PRODUCTION_SITE = 'PRODUCTION_SITE',
    DROPOFF_CENTER = 'DROPOFF_CENTER',
}

export enum OperationalDays {
    MONDAY_FRIDAY = 'MONDAY_FRIDAY',
    MONDAY_SUNDAY = 'MONDAY_SUNDAY',
    SUNDAY_THURSDAY = 'SUNDAY_THURSDAY',
    MONDAY_SATURDAY = 'MONDAY_SATURDAY',
}

export enum OperatingHours {
    ALL_DAY = 'ALL_DAY',
    CUSTOM_HOURS = 'CUSTOM_HOURS',
}

export enum ExpectedContainerStatus {
    TO_BE_REPAIRED = 'TO_BE_REPAIRED',
    TO_BE_MAINTAINED = 'TO_BE_MAINTAINED',
    TO_BE_OVERHAULED = 'TO_BE_OVERHAULED',
    TO_BE_RECYCLED = 'TO_BE_RECYCLED',
    OK = 'OK',
}

export enum LoggerStatus {
    ACTIVE = 'ACTIVE',
    DECOMMISSIONED = 'DECOMMISSIONED',
    OUT_OF_SERVICE = 'OUT_OF_SERVICE',
    READY_TO_SHIP = 'READY_TO_SHIP',
    SERVICE = 'SERVICE',
}

export enum LoggerPosition {
    AMBIENT = 'AMBIENT',
    INTERNAL = 'INTERNAL',
    TOP = 'TOP',
    BOTTOM = 'BOTTOM',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    BACK = 'BACK',
    DOOR = 'DOOR',
    UNSPECIFIED = 'UNSPECIFIED',
    CF_AMBIENT = 'CF_AMBIENT',
    AMBIENT_TEST = 'Ambient Test',
    DOOR_TEST = 'Door Test',
}

export enum LoggerDataTypes {
    TEMPERATURE = 'TEMPERATURE',
    LOCATION_LATITUDE = 'LOCATION_LATITUDE',
    LOCATION_LONGITUDE = 'LOCATION_LONGITUDE',
    DOOR = 'DOOR',
    MESSAGE_ID = 'MESSAGE_ID',
    TEMPERATURE_MEASUREMENT_TIMESTAMP = 'TEMPERATURE_MEASUREMENT_TIMESTAMP',
    BATTERY_VOLTAGE = 'BATTERY_VOLTAGE',
    BATTERY_VOLTAGE_DROP = 'BATTERY_VOLTAGE_DROP',
    MARKER = 'MARKER',
    GATEWAY_NUMBER = 'GATEWAY_NUMBER',
    RSSI = 'RSSI',
    SNR = 'SNR',
    IS_INVALID = 'IS_INVALID',
    IS_RESET_DEVICE = 'IS_RESET_DEVICE',
    IS_HISTORICAL = 'IS_HISTORICAL',
    RELATIVE_HUMIDITY = 'RELATIVE_HUMIDITY',
    BATTERY_LEVEL = 'BATTERY_LEVEL',
    IS_HISTORIC_READOUT = 'IS_HISTORIC_READOUT',
}

export enum LoggerExchangeReason {
    LOGGER_DATA_ISSUE_RED_LED = 'LOGGER_DATA_ISSUE_RED_LED',
    ASSET_TO_BE_REPAIRED_SCRAPPED = 'ASSET_TO_BE_REPAIRED_SCRAPPED',
    LOGGER_DAMAGED_NOT_RESPONSIVE = 'LOGGER_DAMAGED_NOT_RESPONSIVE',
    LOGGER_MISSING = 'LOGGER_MISSING',
    LOGGER_OR_ASSET_ID_INCORRECT = 'LOGGER_OR_ASSET_ID_INCORRECT',
    CALIBRATION_EXPIRED = 'CALIBRATION_EXPIRED',
}

export enum LoggerMode {
    STAND_BY = 'STAND_BY',
    ACTIVE = 'ACTIVE',
    FIRMWARE_UPDATE_IN_PROGRESS = 'FIRMWARE_UPDATE_IN_PROGRESS',
}

export enum TransportModeRoad {
    FTL = 'FTL',
    FTL_OR_LTL = 'FTL_OR_LTL',
    LTL = 'LTL',
}

export enum HandoverTime {
    TIME_0000 = 'TIME_0000',
    TIME_0100 = 'TIME_0100',
    TIME_0200 = 'TIME_0200',
    TIME_0300 = 'TIME_0300',
    TIME_0400 = 'TIME_0400',
    TIME_0500 = 'TIME_0500',
    TIME_0600 = 'TIME_0600',
    TIME_0700 = 'TIME_0700',
    TIME_0800 = 'TIME_0800',
    TIME_0900 = 'TIME_0900',
    TIME_1000 = 'TIME_1000',
    TIME_1100 = 'TIME_1100',
    TIME_1200 = 'TIME_1200',
    TIME_1300 = 'TIME_1300',
    TIME_1400 = 'TIME_1400',
    TIME_1500 = 'TIME_1500',
    TIME_1600 = 'TIME_1600',
    TIME_1700 = 'TIME_1700',
    TIME_1800 = 'TIME_1800',
    TIME_1900 = 'TIME_1900',
    TIME_2000 = 'TIME_2000',
    TIME_2100 = 'TIME_2100',
    TIME_2200 = 'TIME_2200',
    TIME_2300 = 'TIME_2300',
}

export enum IncoTerm {
    EXW = 'EXW',
    FCA = 'FCA',
    FAS = 'FAS',
    FOB = 'FOB',
    CFR = 'CFR',
    CIF = 'CIF',
    CPT = 'CPT',
    CIP = 'CIP',
    DAP = 'DAP',
    DPU = 'DPU',
    DDP = 'DDP',
}

export enum OrderIncoTerm {
    FCA = 'FCA',
    CIF = 'CIF',
    CPT = 'CPT',
}

export enum PreliminaryInvoiceCurrency {
    CHF = 'CHF',
    EUR = 'EUR',
    TWD = 'TWD',
    USD = 'USD',
}

export enum NotificationsOptions {
    ALL_ACTIVATED = 'ALL_ACTIVATED',
    ALL_DEACTIVATED = 'ALL_DEACTIVATED',
    ADVANCED_SETTINGS_ENABLED = 'ADVANCED_SETTINGS_ENABLED',
}

export enum StatusLongTermLease {
    NOT_STARTED = 'NOT_STARTED',
    CONFIRMED = 'CONFIRMED',
    BOOKED = 'BOOKED',
    RENTAL = 'RENTAL',
    CLOSED = 'CLOSED',
}

export enum OrderCancellationReasons {
    CANCELLATION_CONTAINER_UNAVAILABILITY = 'CANCELLATION_CONTAINER_UNAVAILABILITY',
    CUSTOMER_REQUEST_POSTPONEMENT_REBOOKED = 'CUSTOMER_REQUEST_POSTPONEMENT_REBOOKED',
    CANCELLATION_CUSTOMER_REQUEST = 'CANCELLATION_CUSTOMER_REQUEST',
    CANCELLATION_OTHER = 'CANCELLATION_OTHER',
    CANCELLATION_TRUCK_UNAVAILABILITY = 'CANCELLATION_TRUCK_UNAVAILABILITY'
}

export enum DeliveryServiceType {
    DELIVERY_ROAD = 'DELIVERY_ROAD',
    PICKUP = 'PICKUP',
}

export enum CollectionServiceType {
    COLLECTION = 'COLLECTION',
    DROPOFF_FORWARDER = 'DROPOFF_FORWARDER',
    DROPOFF_SKYCELL = 'DROPOFF_SKYCELL',
    DROPOFF_AIRPORT = 'DROPOFF_AIRPORT',
}

export enum OrderTypes {
    CUSTOMER_TRANSPORT = 'CUSTOMER_TRANSPORT',
    INTERNAL_TRANSPORT = 'INTERNAL_TRANSPORT',
    LONG_TERM_RENTAL = 'LONG_TERM_RENTAL',
}

export enum OrderSubType {
    LONG_TERM_RENTAL = 'LONG_TERM_RENTAL',
    DIRECT_LEASE = 'DIRECT_LEASE',
    AIRLINE_LEASE = 'AIRLINE_LEASE',
    EVENT = 'EVENT',
    GENERAL_FREIGHT = 'GENERAL_FREIGHT',
    STOCK_TRANSFER = 'STOCK_TRANSFER',
    REVERSE_LOGISTICS = 'REVERSE_LOGISTICS',
}

export enum OrderTransportModeRoad {
    FTL = 'FTL',
    LTL = 'LTL',
}

export enum DeliveryOptionRoad {
    VANS = 'VANS',
    TRUCKS = 'TRUCKS',
}

export enum OrderStepStatus {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    CLOSED = 'CLOSED',
    CLOSED_INCOMPLETE_INFORMATION = 'CLOSED_INCOMPLETE_INFORMATION',
}

export enum OrderStatusTransitionTo {
    NOT_STARTED = 'NOT_STARTED',
    SELECTED = 'SELECTED',
    BOOKED = 'BOOKED',
    TRANSPORT = 'TRANSPORT',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
    RESERVED = 'RESERVED',
    TO_BE_PROVISIONED = 'TO_BE_PROVISIONED',
    READY_TO_SHIP = 'READY_TO_SHIP',
    POSITIONING = 'POSITIONING'
}

export enum OrderStepType {
    ROAD = 'ROAD',
    AIR = 'AIR',
    SEA = 'SEA',
    CONFIRMATION = 'CONFIRMATION',
    EVENT = 'EVENT',
    CUSTOMS = 'CUSTOMS',
    RAIL = 'RAIL'
}

export enum DangerousGoods {
    CLASS_1_1 = 'CLASS_1_1',
    CLASS_1_2 = 'CLASS_1_2',
    CLASS_1_3 = 'CLASS_1_3',
    CLASS_1_4 = 'CLASS_1_4',
    CLASS_1_5 = 'CLASS_1_5',
    CLASS_1_6 = 'CLASS_1_6',
    CLASS_2_1 = 'CLASS_2_1',
    CLASS_2_2 = 'CLASS_2_2',
    CLASS_2_3 = 'CLASS_2_3',
    CLASS_3 = 'CLASS_3',
    CLASS_4_1 = 'CLASS_4_1',
    CLASS_4_2 = 'CLASS_4_2',
    CLASS_4_3 = 'CLASS_4_3',
    CLASS_5_1 = 'CLASS_5_1',
    CLASS_5_2 = 'CLASS_5_2',
    CLASS_6 = 'CLASS_6',
    CLASS_7 = 'CLASS_7',
    CLASS_8 = 'CLASS_8',
    CLASS_9 = 'CLASS_9',
}

export enum InvoiceStatus {
    CREATED = 'CREATED',
    PAID = 'PAID',
    SENTTOSAP = 'SENTTOSAP',
    SENTTOBILLINGCOMPANY = 'SENTTOBILLINGCOMPANY',
}

export enum TransportModeSea {
    FCL = 'FCL',
    LCL = 'LCL'
}

export enum DefaultTruckingComment {
    TRUCKING_COMMENT_TAIL_LIFT = 'TRUCKING_COMMENT_TAIL_LIFT',
    TRUCKING_COMMENT_PICKUP_ASAP = 'TRUCKING_COMMENT_PICKUP_ASAP',
    TRUCKING_COMMENT_DELIVER_ASAP = 'TRUCKING_COMMENT_DELIVER_ASAP',
    TRUCKING_COMMENT_STRAP_BELTS = 'TRUCKING_COMMENT_STRAP_BELTS',
    TRUCKING_COMMENT_DAMAGED_CONTAINERS = 'TRUCKING_COMMENT_DAMAGED_CONTAINERS',
    TRUCKING_COMMENT_ISF_COPY = 'TRUCKING_COMMENT_ISF_COPY',
}

export enum SeaFreightCarrier {
    COSCO = 'COSCO',
    EVERGREEN = 'EVERGREEN',
    OOCL = 'OOCL',
    MAERSK = 'MAERSK',
    MSC = 'MSC',
    HAPAG_LLOYD = 'HAPAG_LLOYD',
    CMA_CGM = 'CMA_CGM',
    HYUNDAI = 'HYUNDAI',
    YANG_MING = 'YANG_MING',
    ZIM = 'ZIM',
    MOL = 'MOL',
    HAMBURG_SUUD = 'HAMBURG_SUUD',
    APL = 'APL',
    SM_LINES = 'SM_LINES',
    ONE = 'ONE'
}

export enum PositionType {
    LEASE = 'LEASE',
    FEE = 'FEE',
    CANCELLATION = 'CANCELLATION',
    DAMAGE = 'DAMAGE',
    LOSS = 'LOSS'
}

export enum InvoiceNormalAddon {
    ADDON = 'ADDON',
    NORMAL = 'NORMAL',
}

export enum InvoiceBulkOrIndividual {
    BULK = 'BULK',
    INDIVIDUAL = 'INDIVIDUAL'
}

export enum OrderPostponementReason {
    CUSTOMER_REQUEST = 'CUSTOMER_REQUEST',
    INTERNAL_REQUEST = 'INTERNAL_REQUEST',
}

export enum ResponsibleDepartment {
    R_D = 'R_D',
    MARKETING = 'MARKETING',
    PRODUCTION = 'PRODUCTION',
    DAILY_OPERATIONS = 'DAILY_OPERATIONS',
    POOLING = 'POOLING',
    MRO = 'MRO',
    COMMERCIAL_OPERATIONS = 'COMMERCIAL_OPERATIONS',
    IMPROVEMENTS_QUALITY = 'IMPROVEMENTS_QUALITY',
    IOT_VALIDATIONS_OPERATIONS = 'IOT_VALIDATIONS_OPERATIONS',
}

export enum OrderModificationType {
    INTERNAL = 'INTERNAL',
    CUSTOMER = 'CUSTOMER',
}

export enum OrderModificationReason {
    CUSTOMER = 'CUSTOMER',
    INTERNAL = 'INTERNAL',
    INTERNAL_REQUEST_CONTAINER_SWAP = 'INTERNAL_REQUEST_CONTAINER_SWAP',
}

export enum MainMeansOfTransport {
    SEA = 'SEA',
    AIR = 'AIR',
    ROAD = 'ROAD',
    RAIL = 'RAIL'
}

export enum Count {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
    THIRD = 'THIRD',
}

export enum SentStatus {
    FAIL = 'FAIL',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
}

export enum CustomerOrderSource {
    BOOKING_PORTAL = 'BOOKING_PORTAL',
    SKYNET = 'SKYNET',
}

export enum Selection {
    DEFAULT = 'DEFAULT',
    BACKUP = 'BACKUP'
}

export enum PositioningSelection {
    DEFAULT = 'DEFAULT',
    BACKUP = 'BACKUP',
    OTHER = 'OTHER'
}

export enum AvailabilityStatus {
    READY_TO_CONFIRM = 'READY_TO_CONFIRM',
    CAN_BE_CONFIRMED = 'CAN_BE_CONFIRMED',
    NOT_ENOUGH = 'NOT_ENOUGH',
    NO_MODEL_AVAILABLE = 'NO_MODEL_AVAILABLE',
    NOT_SUPPORTED_IN_SC = 'NOT_SUPPORTED_IN_SC',
}

export enum DestinationSelection {
    LOCATION = 'LOCATION',
    COUNTRY = 'COUNTRY',
    REGION = 'REGION',
}

export enum TransportModes {
    ROAD = 'ROAD',
    SEA = 'SEA',
    AIR = 'AIR'
}

export enum SeaContainerLoad {
    FCL = 'FCL',
    LCL = 'LCL',
}

export enum PreBookingStatus {
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    ORDER_CREATED = 'ORDER_CREATED',
}

export enum PreBookingReasonForChange {
    MANUAL_ERROR = 'MANUAL_ERROR',
    CUSTOMER = 'CUSTOMER',
    INTERNAL = 'INTERNAL',
}

export enum PreBookingContainerStatus {
    PENDING = 'PENDING',
    CONTAINERS_AVAILABLE = 'CONTAINERS_AVAILABLE',
    CONTAINERS_UNAVAILABLE = 'CONTAINERS_UNAVAILABLE',
}

export enum EmbargoType {
    EMBARGO = 'EMBARGO',
    CLOSELY_MONITORED_BY_USA = 'CLOSELY_MONITORED_BY_USA'
}

export enum ActivityRecordType {
    MEETING = 'MEETING',
    CALL = 'CALL',
    EMAIL = 'EMAIL',
}

export enum AttitudeToSkyCell {
    DISLIKES_US = 'DISLIKES_US',
    DOES_NOT_KNOW_US = 'DOES_NOT_KNOW_US',
    KNOWS_US = 'KNOWS_US',
    LIKES_US = 'LIKES_US',
    UNKNOWN = 'UNKNOWN'
}

export enum LeadSource {
    EVENTS = 'EVENTS',
    WEBINARS = 'WEBINARS',
    REFERRALS = 'REFERRALS',
    DIRECT_SALES_OUTREACH = 'DIRECT_SALES_OUTREACH',
    PARTNERSHIPS = 'PARTNERSHIPS',
    ORGANIC = 'ORGANIC',
    PAID = 'PAID',
    PHYSICAL_EVENTS = 'PHYSICAL_EVENTS',
    DIRECT = 'DIRECT',
    ZOHO = 'ZOHO',
}

export enum Department {
    ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
    ADMINISTRATIVE = 'ADMINISTRATIVE',
    BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
    CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
    FINANCE = 'FINANCE',
    LOGISTICS_AND_DISTRIBUTION = 'LOGISTICS_AND_DISTRIBUTION',
    MARKETING = 'MARKETING',
    OPERATIONS = 'OPERATIONS',
    QUALITY_ASSURANCE = 'QUALITY_ASSURANCE',
    REGULATORY_AFFAIRS = 'REGULATORY_AFFAIRS',
    RESEARCH_AND_DEVELOPMENT = 'RESEARCH_AND_DEVELOPMENT',
    SUPPLY = 'SUPPLY',
    SUSTAINABILITY = 'SUSTAINABILITY',
}

export enum DecisionMakingUnit {
    DECISION_MAKER = 'DECISION_MAKER',
    GATEKEEPER = 'GATEKEEPER',
    INFLUENCER = 'INFLUENCER',
    TEAM_MEMBER = 'TEAM_MEMBER',
    UNKNOWN = 'UNKNOWN',
}

export enum GatewayStatus {
    TO_BE_INSTALLED = 'TO_BE_INSTALLED',
    STOCK = 'STOCK',
    INSTALLED = 'INSTALLED',
    EXPERIMENTAL = 'EXPERIMENTAL',
    UNKNOWN = 'UNKNOWN',
    DECOMMISSIONED = 'DECOMMISSIONED',
    UNDER_INVESTIGATION = 'UNDER_INVESTIGATION',
    MAINTENANCE = 'MAINTENANCE',
    TO_BE_REFURBISHED = 'TO_BE_REFURBISHED',
}

export enum GatewayType {
    CARTASENSE_ETHERNET = 'CARTASENSE_ETHERNET',
    CARTASENSE_GSM = 'CARTASENSE_GSM',
    CARTASENSE_2G = 'CARTASENSE_2G',
    LORA_MIROMICO = 'LORA_MIROMICO',
    MR900 = 'MR900',
}

export enum GatewayMainType {
    CARTASENSE = 'CARTASENSE',
    LORA = 'LORA',
}

export enum GatewayStorageArea {
    C = 'C',
    CRT = 'CRT',
    DRY = 'DRY',
    OPERATIONAL = 'OPERATIONAL',
    RECEPTION = 'RECEPTION',
    FREEZER = 'FREEZER',
    OFFICE = 'OFFICE',
    BACKUP = 'BACKUP',
    PRECONUNIT = 'PRECONUNIT',
    TRAILER = 'TRAILER',
    UNKNOWN = 'UNKNOWN'
}

export enum GatewayDataPlan {
    LAN = 'LAN',
    WLAN = 'WLAN',
    LOCALSIM = 'LOCALSIM',
    TELECOM26 = 'TELECOM26',
    SWISSCOM = 'SWISSCOM',
}

export enum GatewayLocationCategory {
    SERVICECENTER = 'SERVICECENTER',
    AIRPORTSERVICECENTER = 'AIRPORTSERVICECENTER',
    CUSTOMER = 'CUSTOMER',
    REVERSELOGISTICS = 'REVERSELOGISTICS',
    INTERNAL = 'INTERNAL',
    FREIGHTFORWARDER = 'FREIGHTFORWARDER',
}

export enum GatewayHardwareVersion {
    V_1_0 = 'V_1_0',
    V_2_0 = 'V_2_0',
    V_2_1 = 'V_2_1',
    V_2_2 = 'V_2_2',
    V_2_3 = 'V_2_3',
    V_3_0 = 'V_3_0',
    V_3_1 = 'V_3_1',
    V_4_0 = 'V_4_0',
}

export enum GatewaySoftwareVersion {
    V_2_0_0 = 'V_2_0_0',
    V_2_1_0 = 'V_2_1_0',
    V_2_2_0 = 'V_2_2_0',
    V_2_3_0 = 'V_2_3_0',
    V_2_4_0 = 'V_2_4_0',
}

export enum CO2SimulationTechnology {
    SKYCELL_HYBRID = 'SKYCELL_HYBRID',
    ACTIVE = 'ACTIVE',
    PASSIVE = 'PASSIVE',
}

export enum CO2SimulationMethodology {
    GLEC = 'GLEC',
    MY_CLIMATE = 'MY_CLIMATE',
}

export enum MilestoneSource {
    CUSTOMER = 'CUSTOMER',
    CUSTOMER_SKYCELL = 'CUSTOMER_SKYCELL',
    SKYCELL = 'SKYCELL'
}

export enum SimulationStepType {
    AIRPORT = 'AIRPORT',
    CUSTOMS = 'CUSTOMS',
    FERRY = 'FERRY',
    FLIGHT = 'FLIGHT',
    LOAD_PALLET = 'LOAD_PALLET',
    RAMP = 'RAMP',
    RE_ICING = 'RE_ICING',
    TRUCK = 'TRUCK',
    WAREHOUSE = 'WAREHOUSE',
}

export enum SimulationProfile {
    SUMMER = 'SUMMER',
    WINTER = 'WINTER',
    WINTER_TO_SUMMER = 'WINTER_TO_SUMMER',
    SUMMER_TO_WINTER = 'SUMMER_TO_WINTER',
}

export enum AdditionalFeesAllowed {
    BASIC_READOUT = 'BASIC_READOUT',
    CANCELLATION = 'CANCELLATION',
    DAMAGE_DEDUCTIBLE = 'DAMAGE_DEDUCTIBLE',
    EXPRESS_ORDER = 'EXPRESS_ORDER',
    EXTRA_DAY = 'EXTRA_DAY',
    INSURANCE = 'INSURANCE',
    LATE_DELIVERY = 'LATE_DELIVERY',
    MILESTONE_READOUT = 'MILESTONE_READOUT',
    POSTPONEMENT = 'POSTPONEMENT',
    WEEKEND_DELIVERY = 'WEEKEND_DELIVERY',
    MANUAL_CONTAINER_FEE_A = 'MANUAL_CONTAINER_FEE_A',
    MANUAL_CONTAINER_FEE_B = 'MANUAL_CONTAINER_FEE_B',
    MANUAL_SHIPMENT_FEE_A = 'MANUAL_SHIPMENT_FEE_A',
    MANUAL_SHIPMENT_FEE_B = 'MANUAL_SHIPMENT_FEE_B',
}

export enum LaneFeesAllowed {
    COLLECTION = 'COLLECTION',
    BASE_LEASE = 'BASE_LEASE',
    CARGO_STRAPS = 'CARGO_STRAPS',
    DAMAGE_WAIVER = 'DAMAGE_WAIVER',
    DELIVERY_FTL_TRUCK = 'DELIVERY_FTL_TRUCK',
    DELIVERY_FTL_VAN = 'DELIVERY_FTL_VAN',
    DELIVERY_LTL = 'DELIVERY_LTL',
    DRY_ICE = 'DRY_ICE',
    HANDOVER = 'HANDOVER',
    RETURN_DROPOFF = 'RETURN_DROPOFF',
}

export enum OtherFeesAllowed {
    CARGO_STRAPS = 'CARGO_STRAPS',
    DAMAGE_WAIVER = 'DAMAGE_WAIVER',
    DRY_ICE = 'DRY_ICE',
}

export enum LongTermLeaseFeesAllowed {
    ACTIVE_MONITORING = 'ACTIVE_MONITORING',
    ADDITIONAL_PRECON_FEE = 'ADDITIONAL_PRECON_FEE',
    BASE_LEASE = 'BASE_LEASE',
    CARGO_STRAPS = 'CARGO_STRAPS',
    COLLECTION_FTL_TRUCK = 'COLLECTION_FTL_TRUCK',
    COLLECTION_FTL_VAN = 'COLLECTION_FTL_VAN',
    COLLECTION_LTL = 'COLLECTION_LTL',
    DAMAGE_WAIVER = 'DAMAGE_WAIVER',
    DELIVERY_FTL_TRUCK = 'DELIVERY_FTL_TRUCK',
    DELIVERY_FTL_VAN = 'DELIVERY_FTL_VAN',
    DELIVERY_LTL = 'DELIVERY_LTL',
    DRY_ICE = 'DRY_ICE',
    GATEWAY_DEPOSIT = 'GATEWAY_DEPOSIT',
    HANDOVER = 'HANDOVER',
    REPLACEMENT_FEE = 'REPLACEMENT_FEE',
    SERVICE_FEE = 'SERVICE_FEE',
    SHIPMENT_FEE = 'SHIPMENT_FEE',
}

export enum SimplifiedCQuoteStatus {
    WON = 'WON',
    LOST = 'LOST',
    UNKNOWN = 'UNKNOWN',
}

export enum CreditNoteReasons {
    INTERNAL_PROCESS = 'INTERNAL_PROCESS',
    INTERNAL_HUMAN_ERROR = 'INTERNAL_HUMAN_ERROR',
    INTERNAL_PARTNERS = 'INTERNAL_PARTNERS',
    GOODWILL_CLIENT_RELATIONSHIP = 'GOODWILL_CLIENT_RELATIONSHIP',
    STRATEGIC_GROW = 'STRATEGIC_GROW',
}

export enum TaxClassificationEnum {
    TAX_EXEMPT = 'TAX_EXEMPT',
    LIABLE_FOR_TAXES = 'LIABLE_FOR_TAXES',
    EU_CUSTOMER = 'EU_CUSTOMER',
    LIABLE_FOR_TAXES_SP = 'LIABLE_FOR_TAXES_SP',
    DOMESTIC_IC = 'DOMESTIC_IC',
    ES_EQUALIZATION_TAX = 'ES_EQUALIZATION_TAX',
    FT_EU_SAL_NO_VAT_ID = 'FT_EU_SAL_NO_VAT_ID',
    IE_2_3RD_HIGHER_RATE = 'IE_2_3RD_HIGHER_RATE',
    IE_2_3RD_LOWER_RATE = 'IE_2_3RD_LOWER_RATE',
    CANARY_ISLAND = 'CANARY_ISLAND',
    DUTY_FREE_ZONE = 'DUTY_FREE_ZONE',
    GOVERNMENT = 'GOVERNMENT',
}

export enum ForwarderCategory {
    CONSOLIDATEDPOINT = 'CONSOLIDATEDPOINT',
    CUSTOMS = 'CUSTOMS',
    EXPORT = 'EXPORT',
    EXPORT_AIR = 'EXPORT_AIR',
    EXPORT_ROAD = 'EXPORT_ROAD',
    EXPORT_SEA = 'EXPORT_SEA',
    IMPORT = 'IMPORT',
    IMPORT_AIR = 'IMPORT_AIR',
    IMPORT_ROAD = 'IMPORT_ROAD',
    IMPORT_SEA = 'IMPORT_SEA',
    POSITIONING = 'POSITIONING',
    POSITIONING_AIR = 'POSITIONING_AIR',
    POSITIONING_ROAD = 'POSITIONING_ROAD',
    POSITIONING_SEA = 'POSITIONING_SEA',
    TRUCKING = 'TRUCKING',
}

export enum ChangeApprovalRequestStatus {
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
}

export enum PreconditioningTechnology {
    REEFER = 'REEFER',
    FREEZER = 'FREEZER',
    CRT_AMBIENT_ROOM = 'CRT_AMBIENT_ROOM'
}

export enum SeaFreightContainerSize {
    TWENTY_FEET = 'TWENTY_FEET',
    FORTY_FEET = 'FORTY_FEET',
    TWENTY_AND_FORTY_FEET = 'TWENTY_AND_FORTY_FEET',
}

export enum MainDelayReason {
    EARLY_DELIVERY_CUSTOMER_ACCEPTED = 'EARLY_DELIVERY_CUSTOMER_ACCEPTED',
    DELAY_CAUSED_BY_MULTIPLE_TRUCKS_SLOTS = 'DELAY_CAUSED_BY_MULTIPLE_TRUCKS_SLOTS',
    DELAY_CAUSED_BY_SERVICE_CENTER = 'DELAY_CAUSED_BY_SERVICE_CENTER',
    DELAY_CAUSED_BY_CUSTOMER = 'DELAY_CAUSED_BY_CUSTOMER',
    DELAY_CAUSED_BY_TRUCKING_COMPANY = 'DELAY_CAUSED_BY_TRUCKING_COMPANY',
    DELAY_CAUSED_BY_SKYCELL = 'DELAY_CAUSED_BY_SKYCELL',
    OTHER = 'OTHER'
}

export enum SpecificDelayReason {
    CONTAINER_NOT_READY = 'CONTAINER_NOT_READY',
    BLOCKED_LOADING_RAMPS = 'BLOCKED_LOADING_RAMPS',
    TRUCK_DELAY = 'TRUCK_DELAY',
    TRUCK_CANCELLATION = 'TRUCK_CANCELLATION',
    INCORRECT_TEMP_SET_POINT = 'INCORRECT_TEMP_SET_POINT',
    INCORRECT_TRUCK_SIZE = 'INCORRECT_TRUCK_SIZE',
    INCORRECT_NUMBER_OF_TRUCKS = 'INCORRECT_NUMBER_OF_TRUCKS',
    WRONG_TRUCK_DETAILS = 'WRONG_TRUCK_DETAILS',
    NO_PICK_UP_DELIVERY_SLOT_BOOKED = 'NO_PICK_UP_DELIVERY_SLOT_BOOKED',
    DRIVE_ISSUE = 'DRIVE_ISSUE',
    DRIVING_TO_WRONG_LOCATION = 'DRIVING_TO_WRONG_LOCATION',
    INCORRECT_ORDER_MANAGEMENT = 'INCORRECT_ORDER_MANAGEMENT',
    DELAYED_CONTAINER_SELECTION = 'DELAYED_CONTAINER_SELECTION',
    CONTAINER_AVAILABILITY = 'CONTAINER_AVAILABILITY',
    TRUCK_BREAKDOWN = 'TRUCK_BREAKDOWN',
    UNEXPECTED_TRAFFIC_JAM = 'UNEXPECTED_TRAFFIC_JAM',
    FORCE_MAJEURE = 'FORCE_MAJEURE',
    OTHER = 'OTHER',
}
